import { getRuntimeEnvValue } from '../runtimeEnv';
import { resolveServiceRequestUrl } from '../utils/serviceRequestUrl';
export const DEFAULT_REST_ENDPOINT = '/api/v1/get-service-history';
function getServiceHistoryTargetUrl(apiUrl) {
    try {
        const baseUrl = new URL(apiUrl);
        baseUrl.pathname = `${baseUrl.pathname.endsWith('/') ? baseUrl.pathname : `${baseUrl.pathname}/`}api/v1/get-service-history`;
        baseUrl.search = '';
        baseUrl.hash = '';
        return baseUrl.href;
    }
    catch {
        return apiUrl;
    }
}
export function getServiceHistoryEndpoint(options = {}) {
    const legacyEndpoint = getRuntimeEnvValue('REST_ENDPOINT') || DEFAULT_REST_ENDPOINT;
    if (options.hostApp !== 'FPG') {
        return legacyEndpoint;
    }
    const apiUrl = getRuntimeEnvValue('API_URL');
    const targetUrl = apiUrl ? getServiceHistoryTargetUrl(apiUrl) : undefined;
    return resolveServiceRequestUrl({
        targetUrl,
        hostApp: options.hostApp,
        legacyEndpoint,
    });
}
